<template>
  <div class="content">
    <div class="header">
      <van-nav-bar
        title="发票详细"
        left-arrow
        :fixed="true"
        :placeholder="true"
        @click-left="$router.go(-1)"
      />
    </div>
    <div class="container">
      <div class="condition">
        <div class="condition-top">
          <img
            v-if="list.invoiceStatus === '1' || list.invoiceStatus === '0'"
            src="../../assets/img/组 11356.png"
            alt=""
          />
          <img v-else src="../../assets/img/组 11356 (1).png" alt="" />
          <span style="font-size: 0.4rem;font-weight: 600;color: #000000">{{
            list.invoiceStatusStr
          }}</span>
        </div>
        <p
          v-if="list.invoiceStatus == '1'"
          style="font-size: 0.4rem;font-family: PingFang SC;font-weight: 500;color: #333333;"
        >
          预计发票金额：¥{{ list.totalMoney }} <br />
          订单完成后，我们将为您开具发票
        </p>
      </div>

      <div>
        <div class="invoiceIft" v-if="list.invoiceStatus != '0'">
          <van-cell-group>
            <van-field label="发票类型" :value="list.invoiceType" readonly />
            <van-field label="发票内容" value="商品明细" readonly />
            <van-field label="发票抬头" :value="list.invoiceHeader" readonly />
            <van-field label="抬头名称" :value="list.headerName" readonly />
          </van-cell-group>
        </div>
        <div class="productInfo">
          <van-checkbox
            label-disabled
            v-for="(item, index) in list.detailList"
            :key="index"
          >
            <van-card :title="item.goods_name" :thumb="item.color_img">
              <div slot="tags">
                <van-tag>
                 <div style="width:5rem">
                  <span >{{ item.color_name }}</span>
                  <span style="float:right" v-if="item.num">共{{ item.num }}件</span>
                 </div>
                </van-tag>
                <van-tag class="color">¥{{ item.outer_goods_price }}</van-tag>
              </div>
            </van-card>
           
          </van-checkbox>
          <div class="serial">
              <p>
                <span>下单编号</span> <span>{{ list.recordCode }}</span>
              </p>
              <hr style="background-color:#eee; height:1px; border:none;" />
              <p>
                <span>下单时间</span> <span>{{ list.record_time }}</span>
              </p>
            </div>
        </div>
        <div class="dement" v-if="list.invoiceStatus == '0'">
          <van-button
            plain
            style="margin-right:0.2rem;border: 0.0267rem solid #999999;"
            size="small"
            round
            @click="$router.go(-1)"
            >不开发票</van-button
          >
          <van-button
         
            @click="show = true"
            color="#FC563A"
            type="primary"
            size="small"
            round
            >申请开票</van-button
          >
        </div>
      </div>
    </div>

    <van-action-sheet v-model="show">
      <div class="invoice" style="">
        <!-- title -->
        <div class="title">
          <p
            style="padding-left:0.4267rem;color:#000000;font-weight: 600; fonst-size:0.48rem"
          >
            填写发票信息
          </p>
          <div class="title-right" style="padding-right:0.4267rem">
            <p>
              <span @click="getNotice">发票须知</span
              ><van-icon style="vertical-align: -18%" name="info-o" />
            </p>
            <van-icon @click="show = false" name="cross" />
          </div>
        </div>
        <!-- content -->
        <div>
          <keep-alive>
            <Invoice :money="money" @chengeSubmit="AmountChange" :recordCode2="recordCode2"></Invoice>
          </keep-alive>
        </div>
      </div>
    </van-action-sheet>
    <!-- 发票须知弹窗  -->
    <van-dialog
      v-model="invoiceShow"
      title="发票须知"
      :showConfirmButton="false"
      round-button
      class="invoice-foot"
    >
      <div
        style="color:#000000;font-size:0.32rem;padding: 0 0.4533rem 0  0.72rem;line-height: 0.5067rem;"
      >
        <p>
          1.依照税局最新开票法规，发票开具内容均为明细。
        </p>
        <p>
          2.开票金额为用户实际支付的金额（不含礼品卡与不支持该发票类型的商品实付金额）。
        </p>
        <p>
          3.单笔订单只支持开具一种类型的发票。
        </p>
        <p>
          4.选择开具增值税专用发票时，请确保专票资质信息与贵司税务登记证的信息一致，以免因开票给贵司带来损失。
        </p>
      </div>
      <p style="text-align:center;">
        <van-button
          style="padding:0 1.4rem;height:1rem"
          @click="invoiceShow = false"
          round
          color="#FC563A"
          >确认</van-button
        >
      </p>
    </van-dialog>
  </div>
</template>

<script>
import Invoice from "../../components/invoice/invoice.vue";
import { Toast } from 'vant';
export default {
  components: {
    Invoice,
  },
  data() {
    return {
      list: [],
      show: false,
      invoiceShow: false,
      money:'',
      recordCode2:''
    };
  },
  created() {
    this.getIndent();
 
  },
  methods: {
    getIndent() {
      this.$post({
        url: "/invoice/findInvoiceByRecordCode",
        method: "get",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
          recordCode: this.$route.query.orderCode,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.list = res.data;
            this.money=res.data.totalMoney
            this.recordCode2=res.data.recordCode
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 发票须知
    getNotice() {
         this.invoiceShow=true
    },
    AmountChange(show) {
     this.show=show
     this.getIndent()
     Toast('申请成功');
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  min-height: 100%;
  background-color: #e8e8e8;
  .header {
    /deep/.van-icon-arrow-left::before {
      font-size: 0.533333rem;
      color: black;
    }
    /deep/.van-nav-bar__title {
      font-weight: 600;
    }
  }
  .condition {
    background-color: #fff;
    padding: 0.4rem 0;
    text-align: center;
    .condition-top {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .invoiceIft {
    margin: 0.2rem 0.28rem;
    border-radius: 0.06rem;
    /deep/.van-field__label {
      color: #333;
      font-size: 0.4rem;
      font-weight: 600;
    }
  }
  .productInfo {
    border-radius: 0.06rem;
    margin-top: 0.2rem ;
    .van-checkbox {
      margin: 0 0.28rem;
      background-color: #ffffff;
      /deep/.van-checkbox__icon.van-checkbox__icon--round {
        display: none;
      }
    }
    .van-card {
      height: 3rem;
      background-color: #ffffff;
      border-radius: 8%;
      .colors {
        display: block;
        color: #000 !important;
        font-size: 0.32rem;
      }
      .color {
        display: block;
        font-size: 0.36rem;
        color: #f74b2e !important;
        font-weight: 600;
      }
      .van-card__content {
        margin-top: 0.5rem;
        margin-left: 0.2rem;
        .van-card__title.van-multi-ellipsis--l2 {
          font-size: 0.37rem;
        }
        .van-tag.van-tag--plain.van-tag--default.van-hairline--surround {
          .van-tag.van-tag--plain.van-tag--danger.van-hairline--surround {
            font-size: 0.32rem;
            color: #ccc;
          }
        }
      }
      .van-tag {
        padding: 0.2em 0.3em;
      }
      .van-tag--default {
        padding: 0;
        margin: 0;
        background-color: #fff;
      }
      .van-tag.van-tag--default {
        color: #ccc;
        /deep/p {
          width: 5.2rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .van-card__price {
        color: red;
      }
      /deep/.van-tag {
        margin: 0.213333rem 0;
      }
    }
    .refundInfo {
      float: right;
      margin-right: 0.4rem;
      margin-bottom: 0.4rem;
      font-size: 0.32rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .serial {
      padding: 0.2rem 0.28rem;
      margin: 0 0.28rem;
      font-size: 0.4rem;
      background-color: #ffffff;
      p {
        display: flex;
        justify-content: space-between;
        color: #666;
      }
    }
  }
  .dement {
    background-color: #ffffff;
    margin: 0.2rem 0.28rem;
    border-radius: 0.06rem;
    text-align: end;
    padding: 0.2rem 0.32rem;
  }
  .invoice {
    padding: 0.4533rem 0;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .title-right {
      display: flex;
      align-items: center;
      p {
        display: flex;
        margin-right: 0.2667rem;
        display: block;
        color: #999999;
        font-size: 0.3733rem;
      }
    }
  }
  /deep/.van-dialog {
    height: auto;
    border-radius: 0.5067rem;
  }
  .invoice-foot {
    /deep/.van-button--normal {
      margin: 0.3733rem 0;
      // padding: 0rem 1.2rem;
    }

    /deep/.van-dialog__content {
      margin-top: 0.32rem;
    }
    /deep/.van-dialog__header {
      color: #000000;
      font-size: 0.4533rem;
      font-weight: 600;
    }
  }
}
</style>
